import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";

const POLICIES = [
  { t: "Live arrival guarantee", d: "Every animal is shipped overnight with a guaranteed live arrival. Someone must be available to sign for the package." },
  { t: "Health guarantee", d: "Animals are established feeders, quarantined and health-checked. Report any concern within 48 hours of arrival with photos." },
  { t: "Deposits & reservations", d: "A reservation holds an animal for 14 days. Deposits are non-refundable but transferable to another available animal." },
  { t: "Shipping & weather", d: "We ship only within safe temperature windows. Shipments may be delayed for the animal's safety during extreme weather." },
  { t: "Suitability", d: "Boa constrictors are a long-term commitment. By continuing you confirm you can provide appropriate lifelong husbandry." },
];

export const PolicyDialog = ({ open, onClose, onAccept }) => {
  const [agreed, setAgreed] = useState(false);
  useEffect(() => { if (open) setAgreed(false); }, [open]);
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] bg-black/80 backdrop-blur flex items-center justify-center px-4 py-8" data-testid="policy-dialog">
      <div className="w-full max-w-lg bg-qbsurface border border-white/15 rounded-2xl p-6 md:p-8 max-h-[86vh] overflow-y-auto">
        <div className="flex items-center gap-2 text-qbprimary mb-1"><ShieldCheck className="w-5 h-5" /><h2 className="font-display text-2xl leading-[1.1] pb-0.5">Our policies</h2></div>
        <p className="text-qbfg/50 text-sm mb-6">Please review and agree before continuing.</p>
        <div className="space-y-4">
          {POLICIES.map((p) => (
            <div key={p.t} className="border-l-2 border-qbprimary/40 pl-4">
              <h3 className="font-medium text-qbfg">{p.t}</h3>
              <p className="text-sm text-qbfg/55 mt-1 leading-relaxed">{p.d}</p>
            </div>
          ))}
        </div>
        <label className="flex items-start gap-3 mt-6 text-sm cursor-pointer">
          <input type="checkbox" data-testid="policy-agree-checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="mt-1 accent-[#00F260]" />
          <span className="text-qbfg/80">I have read and agree to the policies above.</span>
        </label>
        <div className="flex gap-3 mt-6">
          <button type="button" data-testid="policy-cancel" onClick={onClose} className="flex-1 px-6 py-3 rounded-full border border-white/20 text-qbfg hover:border-white/40 transition-colors">
            Cancel
          </button>
          <button type="button" data-testid="policy-continue" disabled={!agreed} onClick={onAccept} className="flex-1 px-6 py-3 rounded-full bg-qbprimary text-qbbg font-medium disabled:opacity-40 disabled:cursor-not-allowed enabled:hover:bg-qbfg transition-colors">
            Agree &amp; continue
          </button>
        </div>
      </div>
    </div>
  );
};
